<template>
    <b-card :title="title">
        <b-card-body>
            <b-form @submit.stop.prevent="createOrUpdate">
                <b-form-group
                    id="name-group"
                    label="Name*"
                    label-for="input-name"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="entity-group"
                    label="Entity"
                    label-for="input-entity"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-entity"
                        v-model="model.entity"
                        required
                        :options="entityOptions"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >Select Entity</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    id="flow-group"
                    label="Flow"
                    label-for="input-flow"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-flow"
                        v-model="model.flow"
                        required
                        :options="flowOptions"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >Select Flow</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    id="reference-entity-group"
                    label="Reference"
                    label-for="input-reference-entity"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-reference-entity"
                        v-model="model.reference_entity"
                        required
                        :options="referenceEntityOptions"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >Select Reference Entity</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>
                <b-button-group size="sm">
                    <b-button
                        variant="secondary"
                        :disabled="loading ? true : false"
                        @click="cancel()"
                        >Cancel</b-button
                    >
                    <b-button
                        type="submit"
                        variant="primary"
                        :disabled="loading ? true : false"
                        >{{ submitLabel }}</b-button
                    >
                    <b-button
                        v-if="this.model.id"
                        @click="deleteItem()"
                        class="mr-2"
                        variant="warning"
                    >
                        Delete Item
                    </b-button>
                </b-button-group>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ViewItem',
    mixins: [popupMixins],
    data() {
        return {
            componentName:'Transaction Type',
            title: 'Transaction Type',
            model: {
                id: 0,
                name: null,
                description: null,
                flow: null,
                entity: null,
                reference_entity: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },

        flowOptions() {
            return this.$store.getters['transactionType/flowOptions']
        },

        entityOptions() {
            return this.$store.getters['transactionType/entityOptions']
        },

        referenceEntityOptions() {
            return this.$store.getters['transactionType/referenceEntityOptions']
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) {
            this.model = { ...this.item }
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },

        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'transactionType/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Transaction Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = null //'Unable to delete Transaction Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },

        createOrUpdate() {
            this.loading = true
            const model = { ...this.model }

            console.log('model', model)
            const path = model.id
                ? 'transactionType/update'
                : 'transactionType/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? 'Updated' : 'Created'
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            let message = error.message
                            const interror = 'Internal Server Error'
                            if (interror == error.message)
                                message = 'Duplicate Detected'
                            
                            this.genericToast(`Duplicate ${this.componentName}`,'','warning', 'Transaction Type name provided is already in use, please choose a different name')
                            // this.doToast('Error', message, 'warning')
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        onSubmit() {
            console.log('test')
        },
    },
}
</script>
<style></style>
